import {licenseFeeSvg as Icon__small__licenseFeeSvg} from '../Icon__small/Icon__small--licenseFee.js';
import {licenseFeeSvg as Icon__xsmall__licenseFeeSvg} from '../Icon__xsmall/Icon__xsmall--licenseFee.js';

export var licenseFee = {
  name: 'licenseFee',
  category: 'icon',
  colorable: true,
  svg: Icon__small__licenseFeeSvg,
  alt: {
    Icon__small: Icon__small__licenseFeeSvg,
    Icon__xsmall: Icon__xsmall__licenseFeeSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
